import { FormControlLabel, Radio, RadioGroup, Typography, Box } from '@mui/material';
import { FieldProps } from 'formik';

interface Props {
    label: string;
    trueLabel: string;
    falseLabel: string;
    onChange?: (value: boolean) => void;
}

export default function RadioSwitch(props: FieldProps & Props) {
    const { field, form, label, trueLabel, falseLabel, onChange } = props;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value === 'true';
        form.setFieldValue(field.name, value);

        if (onChange) {
            onChange(value);
        }
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <Typography variant="body1" sx={{ mb: 1 }}>
                {label}
            </Typography>
            <RadioGroup row name={field.name} value={field.value.toString()} onChange={handleChange}>
                <FormControlLabel value="false" control={<Radio disabled={form.isSubmitting} />} label={falseLabel} />
                <FormControlLabel value="true" control={<Radio disabled={form.isSubmitting} />} label={trueLabel} />
            </RadioGroup>
        </Box>
    );
}
